import Vue from 'vue'
import Translations from '@/components/mixins/Translations'

import '@/assets/js/modules/components/'

Vue.mixin(Translations)
